var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6H1C0.448 6 0 5.553 0 5C0 4.447 0.448 4 1 4H23C23.552 4 24 4.447 24 5C24 5.553 23.552 6 23 6ZM23 13H1C0.448 13 0 12.553 0 12C0 11.447 0.448 11 1 11H23C23.552 11 24 11.447 24 12C24 12.553 23.552 13 23 13ZM12 20H23C23.552 20 24 19.553 24 19C24 18.447 23.552 18 23 18H12C11.448 18 11 18.447 11 19C11 19.553 11.448 20 12 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.1b4f738ca9ac418c1f0cf7411958badc.svg";
export { ForwardRef as ReactComponent };